import { render } from "./LegacyCartTable.vue?vue&type=template&id=12f61738"
import script from "./LegacyCartTable.vue?vue&type=script&lang=js"
export * from "./LegacyCartTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__